<template>
  <div class="app-main-content voucher-maintenance">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" :lazy="true" type="card" style="width:100%;">
        <el-tab-pane :label="$t('CargoMsg.Cargo_VoucherList')" name="voucherList">
          <!-- 对应 cargoware的 VoucherList -->
          <voucher-list :account-set="accountSet" :account-set-uuid="accountSet ? accountSet.uuid : ''" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_SearchCreated')" name="voucherQuery">
          <!-- 对应 cargoware的 VoucherQuery -->
          <voucher-query :account-set="accountSet" />
        </el-tab-pane>
      </el-tabs>
      <span style="position: absolute; right: 10px; margin-top: 5px;">
        <el-link :type="lbAccountType" @click="selectAccountSetHandler">{{ lbAccount }}</el-link>
      </span>
    </div>
    <!-- 选择账套 -->
    <account-set-popup
      ref="refAccountSetPopup"
      :visible.sync="accountSetPopup.visible"
      :mode="accountSetPopup.mode"
      :check-fiscal-period="true"
      @select="data=>accountSet=data"
      @cancel="()=>accountSetPopup.visible=false"
    />
  </div>
</template>

<script>
import VoucherList from '@/views/cargo/v0/FinanceManage/VoucherMaintenance/VoucherList'
import VoucherQuery from '@/views/cargo/v0/FinanceManage/VoucherMaintenance/VoucherQuery'
import AccountSetPopup from '@/views/cargo/v0/FinanceManage/FinanceInterface/components/AccountSetPopup'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import moment from 'moment'
import { BSWarningUtil } from '@/class/cargo/model/utils/BSWarningUtil'
export default {
  name: 'VoucherMaintenance',
  components: { VoucherList, VoucherQuery, AccountSetPopup },
  data() {
    return {
      activeTabName: 'voucherList',
      accountSet: null, // 当前账套
      accountSetPopup: { visible: false, mode: 'office' }
    }
  },
  computed: {
    lbAccount() {
      console.log('lbAccount', this.accountSet)
      return this.accountSet === null ? this.$t('CargoMsg.Cargo_PleaseSelectSob') : (this.$t('CargoMsg.Cargo_SetsOfBooksP') + this.accountSet.name)
    },
    lbAccountType() {
      return this.accountSet === null ? 'danger' : 'primary'
    }
  },
  async mounted() {
    const allowFinanceOperation = await BSWarningUtil.checkFinanceExpire(this.$route, this.$router)
    if (!allowFinanceOperation) {
      return
    }
    if (this.accountSet === null) {
      this.selectAccountSetHandler()
    }
    this.setVoucherDate()
  },
  methods: {
    // 选择账套
    selectAccountSetHandler() {
      this.accountSetPopup.visible = true
    },
    // 每次进入模块，刷新凭证日期为今天，这个配置参数只在打开模块时起效，保持和老系统一致
    setVoucherDate() {
      const voucherDate = moment().format('YYYY-MM-DD') // 凭证日期
      LocalStorageUtilsNew.setConfiguration('VoucherDate', voucherDate)
    }
  }
}
String.prototype.format = function() {
  if (arguments.length === 0) return this
  for (var s = this, i = 0; i < arguments.length; i++) {
    s = s.replace(new RegExp('\\{' + i + '\\}', 'g'), arguments[i])
  }
  return s
}
</script>

<style scoped>

</style>
